
export default {
    countProductsInCart(cart) {
        let quantity = 0
        cart.forEach(element => {
            quantity = quantity + element.quantity
        });
    
        return quantity
    },
    findIndexFromItem(data, idSearched) {
        let indexFounded = -1
        data.forEach( (element, index) => {
            if (element.id === idSearched) {
                indexFounded = index
            }
        })

        return indexFounded
    },
    calculateDiscountTotal(cart) {
        let discount_total = 0
        for (let element of cart) {
            discount_total = discount_total + element.discount_value;
        }
        /*
        cart.forEach(element => {
            discount_total = discount_total + element.discount_value;
        });
        */
    
        return discount_total
    },
    calculateSubTotalPrice(cart) {
        let subtotal = 0
        for (let element of cart) {
            if (element.is_bonus == false) {
                subtotal = subtotal + element.price
            }
        }
        /*
        cart.forEach(element => {
            if (element.is_bonus == false) {
                subtotal = subtotal + element.price
            }            
        });
        */
    
        return subtotal
    },
    calculateDiscountValueItem (product) {
        let base_price = parseFloat(product.base_price)
        let quantity = parseFloat(product.quantity)        
        let subtotalItem = parseFloat(base_price * quantity)
        let discount_amount = parseFloat(product.discount_amount)

        let discount_value = 0
        if (product.discount_type === 'Monto') {
            discount_value = discount_amount
        } else if(product.discount_type === 'Porcentaje') {
            discount_value = (discount_amount / 100) * subtotalItem;//product.price
        }

        return discount_value;
    },
    calculatePriceFromProductItem(product){
        let base_price = product.base_price
        let quantity = product.quantity        
        let subtotalItem = base_price * quantity;

        let discount = this.calculateDiscountValueItem(product);

        /*
        if (product.discount_type === 'Monto') {
            discount = product.discount_amount
        } else if(product.discount_type === 'Porcentaje') {
            discount = (product.discount_amount / 100) * subtotalItem;//product.price
        }
        */

        let totalItem = subtotalItem - discount

        return totalItem
    },
    calculateSubTotal(total, por_igv){
        let subtotal = total/(1 + por_igv)
        subtotal = Math.round(subtotal * 100) / 100;

        return subtotal
    },
    calculatCartAmounts (cart) {
        let subtotal = 0;
        let total_bonus = 0;
        let discount_total = 0;
        for (let element of cart) {
            if (element.is_bonus == false) {
                subtotal = subtotal + element.price;
                discount_total = discount_total + element.discount_value;
            } else {
                total_bonus = total_bonus + element.price;
            }
        }

        return {
            subtotal: subtotal,
            total_bonus: total_bonus,
            discount_total: discount_total
        }
    }
}
